
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/latest",
      function () {
        return require("private-next-pages/community/latest.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/latest"])
      });
    }
  